module.exports = __webpack_public_path__ + "static/media/photoProfile.b16968fe.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfilePage/internalComponents/photoProfile.PNG
// module id = 20
// module chunks = 0